/**
 * Texts for Training page
 */
export const trainingPageText = {
    title: 'Opplæring – CamAPS FX',
    titleMeta: 'Vi tilbyr gratis nettbasert opplæring for CamAPS FX brukere',
    descriptionMeta: 'Cambridge Diabetes Education Programme tilbyr gratis nettbasert sertifisert opplæring for personer med diabetes type 1, foresatte, skolepersonell og helsepersonell.',
    keywords: 'camaps training, camaps fx training,  ',
    localeMeta: 'nb_no',
    mainHeader: 'Helseopplæring',
    mainSubHeader: 'Støtt personer som bruker CamAPS FX med ekspertledet opplæring.',
    gettingStartedHeader: 'Komme i gang',
    step1Title: '<strong>Trinn 1:</strong><br/>Last ned appen',
    step2Title: '<strong>Trinn 2:</strong><br/>Opprett en konto',
    step3Title: '<strong>Trinn 3:</strong><br/>Begynn den grunnleggende opplæringen i appen',
    step4Title: '<strong>Trinn 4:</strong><br/>Par med din valgte pumpe og CGM (med godkjenning fra helseteamet ditt) eller utforsk appen med <strong>virtuell modus</strong>',
    videoSrc: '/video/In-app training loop_1.mp4',
    certifiedTrainingTitle: 'Sertifisert opplæring',
    trainingHeader: 'Sertifisert opplæring',
    trainingHeader_2: 'For helsepersonell',
    trainingHeader_3: 'Brukeropplæring',
    trainingHeaderText: 'GRATIS nettbasert opplæring i CamAPS FX levert av Cambridge Diabetes Education Programme (CDEP).',
    websiteLink: 'https://www.camdiabtraining.com/account-sign-in.html',
    websiteLinkHeading: 'CDEP-opplæring',
    getTrained: 'Få opplæring',
    trainingHeaderIat: 'CamAPS FX-trening',
    trainingHeaderTextIat: 'Fullfør den essensielle opplæringen i appen før du bruker CamAPS FX-appen.',
    trainingSubHeaderOneIat: 'Kom i gang',
    trainingSubTextOneIat: 'Last ned CamAPS FX-appen. <br>Opprett en konto for å starte opplæringen.',
    trainingSubHeaderTwoIat: 'Trenger du hjelp med å installere appen?',
    trainingParaTwoStartIat: 'Besøk vår',
    trainingParaTwoEndIat: 'seksjon for veiledning.',
    websiteLinkHeadingSupportIat: 'Support',
    trainingSubHeaderThreeIat: 'Ytterligere ressurser',
    animationsYpsoPumpText: 'Animasjoner',
    animationsAndText: 'og',
    animationsDanaText: 'Animasjoner (Dana-pumpe)',
    animationsFurtherText: 'Lær gjennom trinnvise visuelle forklaringer.',
    webinarsText: 'Webinarer',
    webinarsFurtherText: 'Se ekspertledede sesjoner om bruk av appen.',
    websiteAnimationsYpsoPumpLink: 'https://www.camdiabtraining.com/view/27/mylife-YpsoPump-users.htm',
    websiteAnimationsDanaLink: 'https://www.camdiabtraining.com/view/25/Dana-insulin-pump-users.htm',
    websiteWebinarsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
};
